import React, { useEffect, useState } from 'react';
import { useImpressionManager } from '@fiverr-private/impressionable';
import { useBreakpoint, useIsClient } from '@fiverr-private/hooks';
import { InitialProps } from '../../../types/initialProps';
import { LandingPageProvider } from '../../context/LandingPageContext';
import { LandingPageLayout } from '../../components/LandingPageLayout';
import { reportViewedPageEvent } from '../../utils/mixpanel';

const App = (props: InitialProps) => {
    useImpressionManager();
    const isClient = useIsClient();
    const breakpoint = useBreakpoint() || 'default';
    const [isReported, setIsReported] = useState(false);

    useEffect(() => {
        if (isClient && !isReported) {
            const searchParams = new URLSearchParams(window.location.search);

            const utmCampaign = searchParams.get('utm_campaign') || '';
            const utmSource = searchParams.get('utm_source') || '';

            reportViewedPageEvent(utmCampaign, utmSource, breakpoint);
            setIsReported(true);
        }
    }, [isClient, breakpoint, isReported]);

    return (
        <LandingPageProvider {...props}>
            <LandingPageLayout />
        </LandingPageProvider>
    );
};

export default App;
